import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
/* eslint-disable no-extra-semi */
/**
 * Modal component for displaying error messages.
 * @component
 * @param {Object} props - The component properties.
 * @param {boolean} props.isOpen - Determines whether the modal is visible.
 * @param {string} props.msg - The error message to be displayed.
 * @param {Function} props.resetFunc - Function to execute when the modal is closed.
 */
export default function ErrorModal({ isOpen, msg, resetFunc }) {
    const dispatch = useDispatch();
    const [modal, setModal] = useState(isOpen);
    return (
        <Modal
            isOpen={modal}
            toggle={() => {
                setModal(!modal);
            }}
            centered
        >
            <ModalHeader className="modal-title" />

            <ModalBody className="text-center p-3">
                <lord-icon
                    src="https://cdn.lordicon.com/krenhavm.json"
                    trigger="loop"
                    delay="150"
                    colors="primary:#e83a30,secondary:#e83a30"
                    style={{ width: "120px", height: "120px" }}>
                </lord-icon>
                <div className="mt-4">
                    <h4 className="mb-3">Oops something went wrong!</h4>
                    <p className="text-muted mb-4">{msg}</p>
                    <div className="hstack gap-2 justify-content-center">
                        <Button color="light" onClick={() => {
                            setModal(false);
                            setTimeout(() => {
                                dispatch(resetFunc());
                            }, 150);
                        }}>Close</Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
};